import { render } from "./UseTemplateModal.vue?vue&type=template&id=34850cca&scoped=true"
import script from "./UseTemplateModal.vue?vue&type=script&lang=js"
export * from "./UseTemplateModal.vue?vue&type=script&lang=js"

import "./UseTemplateModal.vue?vue&type=style&index=0&id=34850cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34850cca"]])

export default __exports__